import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/hero/Hero';
import { TrustStrip } from './components/sections/TrustStrip';
import { Problems } from './components/sections/Problems';
import { Solution } from './components/sections/Solution';
import { CoreContent } from './components/sections/CoreContent';
import { InsidePreview } from './components/preview/InsidePreview';
import { Bonuses } from './components/bonuses/Bonuses';
import { Offer } from './components/sections/Offer';
import { Faq } from './components/sections/Faq';
import { FinalComparison } from './components/sections/FinalComparison';
import { Footer } from './components/layout/Footer';
import { StickyBar } from './components/layout/StickyBar';
import { initMetaPixel, PRODUCT_EVENT_PARAMS, trackMetaEvent } from './utils/metaPixel';
const PAGE_TITLE = 'Badminton Class Ready — 12 Ready-to-Teach School Badminton Lessons for Ages 9–12';
const PAGE_DESCRIPTION = 'A 40-page visual PDF guide with twelve complete 40-minute beginner badminton lessons for ages 9–12, plus 5 teaching resources. $27 USD one-time, with five included bonuses.';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'en';
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = PAGE_DESCRIPTION;
  }, []);

  // Meta Pixel: PageView on load, ViewContent once the offer is seen.
  useEffect(() => {
    initMetaPixel();
    const offer = document.getElementById('offer-details');
    if (!offer || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        trackMetaEvent('ViewContent', PRODUCT_EVENT_PARAMS);
        observer.disconnect();
      }
    }, {
      threshold: 0.25
    });
    observer.observe(offer);
    return () => observer.disconnect();
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ucjbrrlok7so">
      <div className="min-h-screen w-full overflow-x-clip bg-ink font-sans text-base text-white" data-id="element-1" data-mp="d4e75xjpjkyt">
        <a href="#main" className="sr-only bg-gold px-5 py-3 font-bold text-ink focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70]" data-id="element-2" data-mp="85uivqhn5x3a">
          Skip to content
        </a>
        <main id="main" data-id="element-3" data-mp="3bn2xm1h2ogts">
          <Hero data-id="element-4" data-mp="3bnmk7vho3te5" />
          <TrustStrip data-id="element-5" data-mp="3bo4l55f9yvse" />
          <Problems data-id="element-6" data-mp="3qb7i9azor2f7" />
          <Solution data-id="element-7" data-mp="3qbppf2nvz11w" />
          <CoreContent data-id="element-8" data-mp="3qc948ai8p9bp" />
          <InsidePreview data-id="element-9" data-mp="3qcinzgcoyk8y" />
          <Bonuses data-id="element-10" data-mp="3lkhdnzz333lk" />
          <Offer data-id="element-11" data-mp="3ljxtsdpvi54w" />
          <Faq data-id="element-12" data-mp="3ljg11r2f691q" />
          <FinalComparison data-id="element-13" data-mp="3liwkadoi9qpa" />
        </main>
        <Footer data-id="element-14" data-mp="2xuwtjdr720ap" />
        <StickyBar data-id="element-15" data-mp="2xud99qe2mzti" />
      </div>
    </MotionConfig>;
}